import React, { useState, useEffect, useCallback } from "react";
import {
  Stepper,
  Step,
  StepLabel,
  CircularProgress
  // StepContent,
  // StepIconProps,
  // Typography
} from '@mui/material';

import StepWizard from "react-step-wizard";
import Box from '@mui/material/Box';
import '.././css/styles.css';

import questionsApplication from '../data/questionnaire-application.json';
import questionsInterest from '../data/questionnaire-interest.json';
import questionsPrimaryAugmentation from '../data/questionnaire-primary-augmentation.json';

import HelpIcon from '@mui/icons-material/Help';
import Check from '@mui/icons-material/Check';
import {PrivacyConcent, PersonalInformation, MedicalHistory, 
  CriteriaQuestions, Completion, AdditionalInformation,
  TokenAuthentication} from './Wizard';
import { StepConnector, stepConnectorClasses, stepLabelClasses, stepClasses } from '@mui/material';
import { styled } from '@mui/material/styles';
import html2pdf from "html2pdf.js";
import _ from "lodash";
import PropTypes from 'prop-types';
import AlertDialog from "./AlertDialogue";
import generateReport from "./GenerateReport";
import AuthProvider from "./AuthProvider";

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 8,
    // left: 'calc(-50% + 20px)',
    // right: 'calc(50% + 20px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#23c0c3ff',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#23c0c3ff',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
    ...theme.applyStyles('dark', {
      borderColor: theme.palette.grey[800],
    }),
  },
}));

const QontoStepIconRoot = styled('div')(({ theme }) => ({
  color: '#eaeaf0',
  display: 'flex',
  height: 22,
  alignItems: 'center',
  '& .QontoStepIcon-completedIcon': {
    color: '#1fa5a5',
    zIndex: 1,
    fontSize: 18,
  },
  '& .QontoStepIcon-circle': {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
  ...theme.applyStyles('dark', {
    color: theme.palette.grey[700],
  }),
  variants: [
    {
      props: ({ ownerState }) => ownerState.active,
      style: {
        color: '#1fa5a5',
      },
    },
  ],
}));

function QontoStepIcon(props) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Check className="QontoStepIcon-completedIcon" />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
};

const CustomStepperRoot = styled(Stepper)(({ theme }) => ({
  [`&.MuiStepper-vertical`]: {
    textAlign: '-webkit-center',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));

const CustomStepLabel = styled(StepLabel)(({ theme }) => ({
  [`&.${stepLabelClasses.alternativeLabel}`]: {
    display: 'flex',
    position: 'relative',
    alignSelf: 'center',
    top: 'auto', 
    transform: 'none',
  },
}));

const CustomConnector = styled(StepConnector)(({ theme }) => ({  
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    margin: 0,
    position: 'static',
    textAlign: '-webkit-center',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      '&::before': {
        backgroundColor: '#e48c80'
      }
      // borderColor: '#784af4',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      '&::before': {
        backgroundColor: '#1fa58fff'
      }
      // borderColor: '#784af4',
    },
  },
  [`& .${stepConnectorClasses.root}`]: {
    padding: 0,
    margin: 0,
  },
[`& .${stepConnectorClasses.line}`]: {
    border: 0,
    width: 3, 
    height: 20,
    display: 'block',
    alignItems: 'center', 
    justifyContent: 'center', 
    left: 0,
    right: 0,
    position: 'static',
    '&::before': {
        content: '""',
        display: 'block',
        width: '100%',
        height: '100%',
        
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundColor: 'grey',
        margin: 0,
        padding: 0,
    },
},
}));

const TrialForm = ({setNotification, setOpenNotification, onClose, questionType, ...props}) => {
  const [honeypot, setHoneypot] = useState('');
  const [stepWizard, setStepWizard] = useState(null);
  const [user, setUser] = useState({});
  const [activeStep, setActiveStep] = useState(0);
  const [formErr, setFormErr] = useState(false); 

  const [loading, setLoading] = useState(false);

  let questions, steps;

  const isPrimaryAugmentation = questionType === "primary-augmentation";

  if (questionType === "application"){
      questions = _.cloneDeep(questionsApplication);
      steps = [
        'Authentication',
        'Privacy Notice',
        'Personal Information',
        'Medical History',
        'Criteria Questions',
        'Confirmation',
        'Complete',
      ];
      // steps = [
      //   '1',
      //   '2',
      //   '3',
      //   '4',
      //   '5',
      //   '6',
      //   'Complete',
      // ];
  } else if (isPrimaryAugmentation) {
    questions = _.cloneDeep(questionsPrimaryAugmentation);
    steps = [
      'Privacy Notice',
      'Personal Information',
      'Confirmation',
      'Complete',
    ];
  } else {
    questions = _.cloneDeep(questionsInterest);
    steps = [
    'Privacy Notice',
    'Personal Information',
    'Confirmation',
    'Complete',
  ];
  }
  const [formState, setFormState] = useState(getInitialFormState(questions));

  function getInitialFormState(questions) {
      const initialFormState = {};

      questions.form.forEach(sectionItem => {
          const sectionId = Object.keys(sectionItem)[0];
          const questionsArray = sectionItem[sectionId];
          
          initialFormState[sectionId] = {};

          questionsArray.forEach(questionBlock => {
              const questionKey = questionBlock.question;
              initialFormState[sectionId][questionKey] = {}; 

              if (questionBlock.text_box && questionBlock.text_box.length > 0) {
                  questionBlock.text_box.forEach((fieldName, index) => {
                      initialFormState[sectionId][questionKey][fieldName] = {
                          ["text"]: '' 
                      };
                  });
              }
              if (questionBlock.radio && questionBlock.radio.length > 0) {
                  initialFormState[sectionId][questionKey]['radio-selection'] = { 'radio': '' };
              }
              if (questionBlock.checkbox && questionBlock.checkbox.length > 0) {
                  initialFormState[sectionId][questionKey]['checkbox-selection'] = { 'checkbox': '' };
              }
          });
      });

      return initialFormState;
  }

  const updateForm = useCallback((field, answer, type, contextKey, clear) => {
    
    // Use the functional update form of setFormState
    setFormState(prevFormState => {
      const newFormState = { ...prevFormState };
      if (!newFormState[type]) {
        newFormState[type] = {};
      }
      if (!newFormState[type][contextKey]) {
        newFormState[type][contextKey] = {};
      }

      if (clear === true) {     
          const existingQuestionData = newFormState[type][contextKey] || {};     
          newFormState[type][contextKey] = {
              ...existingQuestionData,
              [field]: {} 
          };
      } else {       
          const existingContextData = newFormState[type][contextKey][field] || {};
          newFormState[type][contextKey][field] = {
              ...existingContextData, 
              ...answer
          };
      }
      // console.log(newFormState);
      return newFormState;
    });

  }, []);

  const assignStepWizard = (instance) => {
    setStepWizard(instance);
  };

  const assignUser = (val) => {

  };

  const handleStepChange = (e) => {
    // console.log("step change");
    // console.log(e);
    setActiveStep(e.activeStep - 1);
  };

  const pollDeliveryStatus = async (uuid) => {
    const maxAttempts = 60; // 60 * 2s = 120 seconds
    let attempts = 0;

    const interval = setInterval(async () => {
        attempts++;
        try {
            const response = await fetch(`/wp-json/home/check-delivery/${questionType}/${uuid}`);
            const data = await response.json();
            // console.log(data);
            if (data.delivered === true) {
                clearInterval(interval);
                setNotification({type: "success", text: `Email status: successfully ${data.status}!`});
                setOpenNotification(true);
            }
            else if (data.delivered === false && _.get(data, "status", '')) {
                clearInterval(interval);
                setNotification({type: "warning", text: `Email status: ${data.status}. Please contact support.scaffold@ishc.org.au for further assistance.`});
                setOpenNotification(true);
            }
             else if (data.delivered === false && attempts >= maxAttempts) {
                clearInterval(interval);
                setNotification({type: "error", text: `Delivery confirmation timed out, unable to verify delivery. Please contact support.scaffold@ishc.org.au for further assistance.`});
                setOpenNotification(true);
            }
            // onClose();
        } catch (err) {
            console.error("Polling error:", err);
        }
    }, 2000); // Probe every 2 seconds
  };

  const handleComplete = async () => {
    
    let reportTitle = isPrimaryAugmentation ? "Primary Augmentation EOI Report" : "Breast Scaffold Trial - Medical History Report";
    const { reportContainer, email } = generateReport(formState, reportTitle);

    let pdfBlob = await html2pdf().from(reportContainer).output('blob');
    const formData = new FormData();
    
    formData.append('jsonData', JSON.stringify(JSON.stringify({
      "uuid": localStorage.getItem('UUID'), 
      "token": localStorage.getItem('token'),
      "email": email
    }
    )));
    formData.append('pdfFile', pdfBlob, 'patient_report.pdf');
    formData.append('honeypot', honeypot);
    formData.append('email', email);
    // for the loading circleprogress icon
    setLoading(true);
    
    await fetch(`/wp-json/home/upload/${questionType}`, {
      method: 'POST',
      headers: {
          'X-WP-Nonce': window.wpSettings.nonce,
      },
      body: formData,
    })
    .then(async (response) => {
        const data = await response.json();
        if (!response.ok) {
          const error = new Error(data.message || 'Unknown Error');
          error.code = data.code || 'api_error';
          throw error; 
        }
        // console.log('✅ Response from API:', data);
        // setNotification({code: "200", type: "success", text: data.message});
        // setOpenNotification(true);
        setNotification({type: "info", text: `Thanks for your submission, we are just verifying your details.
                          This will take maximum 2 minutes. Please keep this window open during the process.`
                        });
        setOpenNotification(true);
        if (!data.valid){
          setNotification({type: "success", text: `${data.message}`});
        } else {
          pollDeliveryStatus(data.uuid);
        }
        onClose();
    })
    .catch(error => {
        // console.error('❌ API Error:', error);
        setNotification({
          code: error.code || 'fetch_error', 
          type: "error", 
          text: error.message || 'A network error occurred'
        });
        setOpenNotification(true);
        onClose();
    }).finally(() => {
      setLoading(false); 
    });
  }

  const totalSteps = () => {
    return steps.length;
  };

  function CustomStepIcon(props) {
    const { active, completed, className, icon } = props;

    const icons = steps.reduce((obj, key, index) => {
      obj[index] = <HelpIcon />;
      return obj;
    }, {});
    icons['Complete'] = <HelpIcon />;

    return (
      <div
        className={className}
        style={{
          color: completed ? '#1fa5a5' : active ? '#e48c80' : 'gray',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {completed ? <Check /> : icons[String(icon)]}
      </div>
    );
  }

  function showErr(err) {
    setFormErr(err);  
  }

  return (
    <div
      style={{
        margin: 'auto 0', 
        padding: '20px',
        maxWidth: '700px',
        width: '90%', 
      }}
    >
      <AlertDialog 
        title={"Error"}
        text={"Some fields are missing, please complete all required fields."}
        open={formErr}
        showErr={showErr}
      />
      <div style={{ position: 'fixed', top: '15%', left: '3%'}}>
      <Box class="screenStepper" sx={{ width: "100%", position: 'relative', top: '0', alignSelf: 'start', justifySelf: 'start'}}>
        <CustomStepperRoot 
          activeStep={activeStep} 
          connector={<CustomConnector />} 
          orientation="vertical"
          alternativeLabel
        >
          {steps.map((step, index) => (
            <Step key={step}>
              <CustomStepLabel
                sx={{
                  paddingX: "10px",
                  '.MuiStepLabel-label': {
                    fontSize: '10px', // customize your font size
                  },
                }}
                StepIconComponent={CustomStepIcon}
              >{step}</CustomStepLabel>
            </Step>
          ))}
        </CustomStepperRoot>
      </Box>
      </div>

      {/* NOTE: IMPORTANT !! StepWizard must contains at least 2 children components, else got error */}
      
      <div style={{marginTop: '50px'}}>
        {(questionType === "application") ? 
        // <AuthProvider>
          <StepWizard instance={assignStepWizard} onStepChange={handleStepChange}>
            <TokenAuthentication
              hashKey={"TokenAuthentication"} 
              questions={questions}
              user={user}
              assignUser={assignUser}
              totalSteps={totalSteps}
              update={updateForm}
              form={formState}
              showErr={showErr}
              index={1}
            />
            <PrivacyConcent 
              hashKey={"PrivacyConcent"} 
              questions={questions}
              user={user}
              assignUser={assignUser}
              totalSteps={totalSteps}
              update={updateForm}
              form={formState}
              showErr={showErr}
              index={2}
            />
            <PersonalInformation
              hashKey={"PersonalInformation"} 
              questions={questions}
              user={user}
              assignUser={assignUser}
              totalSteps={totalSteps}
              update={updateForm}
              form={formState}
              showErr={showErr}
              index={3}
            />
            <MedicalHistory
              hashKey={"MedicalHistory"} 
              questions={questions}
              user={user}
              assignUser={assignUser}
              totalSteps={totalSteps}
              update={updateForm}
              form={formState}
              showErr={showErr}
              index={4}
            />
            <CriteriaQuestions
              hashKey={"CriteriaQuestions"} 
              questions={questions}
              user={user}
              assignUser={assignUser}
              totalSteps={totalSteps}
              update={updateForm}
              form={formState}
              showErr={showErr}
              index={5}
            />
            <AdditionalInformation
              hashKey={"AdditionalInformation"} 
              questions={questions}
              user={user}
              assignUser={assignUser}
              totalSteps={totalSteps}
              update={updateForm}
              form={formState}
              showErr={showErr}
              index={6}
            />
            <Completion 
              hashKey={"Completion"} 
              showErr={showErr} 
              completeCallback={handleComplete} 
              setHoneypot={setHoneypot}
              />
          </StepWizard>
        // </AuthProvider>
        : 
        <StepWizard instance={assignStepWizard} onStepChange={handleStepChange}>
          <PrivacyConcent 
            hashKey={"PrivacyConcent"} 
            questions={questions}
            user={user}
            assignUser={assignUser}
            totalSteps={totalSteps}
            update={updateForm}
            form={formState}
            showErr={showErr}
            index={1}
          />
          <PersonalInformation
            hashKey={"PersonalInformation"} 
            questions={questions}
            user={user}
            assignUser={assignUser}
            totalSteps={totalSteps}
            update={updateForm}
            form={formState}
            showErr={showErr}
            index={2}
          />
          <AdditionalInformation
            hashKey={"AdditionalInformation"} 
            questions={questions}
            user={user}
            assignUser={assignUser}
            totalSteps={totalSteps}
            update={updateForm}
            form={formState}
            showErr={showErr}
            index={3}
          />
          <Completion 
            hashKey={"Completion"} 
            showErr={showErr} 
            completeCallback={handleComplete}
            setHoneypot={setHoneypot}
          />
        </StepWizard>
        }
      </div>
        <Box class="mobileStepper" sx={{ width: "100%", position:"relative"}}>
          <Stepper 
            activeStep={activeStep} 
            connector={<QontoConnector />}
            alternativeLabel 
            sx={{
              '& .MuiStepConnector-root': {
                left: 'calc(-50% + 20px)',
                right: 'calc(50% + 20px)',
              },
              '& .MuiStepConnector-line': {
                borderTopWidth: 2,
                minHeight: 0,
              },
              '& .MuiStep-root': {
                paddingLeft: 0,
                paddingRight: 0,
              }
            }}
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel 
                  StepIconComponent={QontoStepIcon}
                  sx={{
                    paddingX: "0",
                    '& .MuiStepLabel-label': {
                      fontSize: '10px', 
                      // for mobile devices
                      '@media (max-width: 950px)': {
                        fontSize: '1.6vw',
                      },
                    }
                  }}
                >
                  {label}
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
        {loading && (
          <Box sx={{ mt: 2, textAlign: 'center'}}>
            <CircularProgress sx={{ color: '#e48c80' }}/>
          </Box>
        )}
    </div>
  );
};

export default TrialForm;
